import type { IconType } from '~/modules/link-farm/components/LinkList/link-item-icons';

import type { FeatureFlagKey } from '../experiments/features';

export const INTERNAL_LINK_TYPES = ['performanceDashboard'] as const;
export type InternalLinkType = (typeof INTERNAL_LINK_TYPES)[number];

// These represent link farms that are displayed inside an app (e.g. - Marketing).
// Define here to avoid circular reference with constants.ts.
export const LINK_FARM_APP_CATEGORIES = ['marketing'] as const;

export type LinkFarmAppCategory = (typeof LINK_FARM_APP_CATEGORIES)[number];

// These represent link farms that are displayed directly from the side Nav
// menu (e.g. - Data Tools). Define here to avoid circular reference with types.ts.
export const LINK_FARM_CATEGORIES = [
  'data',
  'distribution',
  'finance',
  'publishing',
] as const;

export type LinkFarmCategory = (typeof LINK_FARM_CATEGORIES)[number];

export interface BaseLink {
  /** True to show the "New" badge on the link. */
  isNew: boolean;

  /**
   * True if the tile represents and internal link (e.g. - Campaign Planner).
   * False otherwise (e.g. - Manage Artist Roster.)
   */
  isInternal: boolean;

  /** If present, will only add the link if the feature flag is on. */
  featureFlagKey?: FeatureFlagKey;

  type?: InternalLinkType;
}

export interface InternalLink extends BaseLink {
  url: string;
  previewImgSrc: string;
  actionTextKey: string;
  descriptionKey: string;
  hasModal?: boolean;
}

export interface ExternalLink extends BaseLink {
  icon: IconType;
  category: string;
  path: string;
  appName: string;
  url: string;
  actionText: string;
  requestAccess: string;
  requireVpn: boolean;
  additionalMaterials: string;
  description: string;
}

export type LinkFarmLink = InternalLink | ExternalLink;
